interface EnvelopeType {
  openBack?: string;
}

interface EnvelopeBottomFrontProps {
  envelope?: EnvelopeType;
}

export const EnvelopeBottomFront = ({envelope}: EnvelopeBottomFrontProps) => (
  <div className="env-wrapper bottom-front env-final">
    <img
      className="env-group env-group__open-bottom-front open-group"
      src={envelope?.openBack}
      alt=""
    />
  </div>
);
